import React from 'react';

// list item for each subject / qualification
// props : title , qualification (Highr National etc), level (HND, etc), qcf (), scqf ( SCQF Level 5, SCQF Level 6), url
// no interactivity.

var SubjectItem = React.createClass({

    render: function(){
        console.log(this.props);

        var scqf = this.props.scqf;
        var qcf = this.props.qcf;
        scqf = scqf.replace(/SCQF Level/g, '');
        qcf = qcf.replace(/QCF Level/g, '');

        /* TODO : check QCF prop */
        if ( scqf == 'NA' ) { scqf = 'QCF Level: ' + qcf; }
        else { scqf = 'SCQF Level: '+scqf; }

        var haystack = this.props.title.toLowerCase();
        var needle = this.props.filterText ? this.props.filterText.toLocaleLowerCase() : '';

        if ( needle.length < 1 || haystack.indexOf( needle ) > -1 ) {

            return (
                <li className="subject--item">
                    <a href={ '/'+this.props.url+'.html?origin=search' } className="clearfix">
                        <span className="list--item--title">{ this.props.title } ({this.props.level})</span>
                        <span className="list--item--count">{ scqf }</span>
                    </a>
                </li>
            );

        }

        else return false;

    }

});

export default SubjectItem;


/** WEBPACK FOOTER **
 ** ./app/SubjectItem.jsx
 **/